export default {
	control: (provided, state) => ({
		...provided,
		border: 'none',
		boxShadow: state.isFocused?'0 0 0 2px #ef3425':'none'
	})
	
}